import React, { useState, useEffect } from "react";
import axios from "axios";

import Navbar from "./navbar";
import RegisterCard from "./registercard";
import litter from "./images/litter1.jpeg";
import puppy from "./images/puppy3.jpeg";
import dog from "./images/afbrtitus.png";
import specialDog from './images/afbr-burna.png'
import { Link } from "react-router-dom";

import "./css_files/registration.css";
import "./css_files/extras.css";

class Registration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dpo: "",
      loaded: false,
      location: "",
      price: "",
      litter_registrations_price: "",
      puppy_registrations_price: "",
      dog_registrations_price: "",
    };
  }

  componentDidMount = () => {
    // this.getcurrentuserLocation()
  };
  render() {
    return (
      <div className="">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-12 brand-yellow-box-shadow">
            <Navbar />
          </div>
        </div>
        <div className="">
          <div className="">
            <div className="">

              {/* <div className="row text-left  align-items-start justify-content-center  
              specialEvent bg-dark py-5 ">
                <div className="col-md-10  register-card my-5 py-5 ">
                  <RegisterCard
                    image_src={specialDog}
                    specialClasses=" text-white py-5"
                    specialEvent={true}
                    title="AFBR EXHIBITION Event Special Registration"
                    className="puppies specialburna d-none "
                    titleClassName="text-warning"
                    text1="Register your dog at our special event on 29/04/2023"
                    text_price={`20.00`}
                    url={'/dog_registrations/20'}
                    text2=""



                  />
                </div>
              </div> */}
              <div className="row text-left  align-items-center justify-content-center mb-5 mt-3 ">
                <div className="col-md-10 register-card my-2 ">
                  <RegisterCard
                    image_src={dog}
                    title="Adult Registration"
                    className="puppies"
                    text1="Register an adult dog with us"
                    text2="Age: above 12 months old"
                    // cancelled_text={'$35.00'}
                    shiftRight="order-1 order-sm-3"
                    text_price={`30.00`}
                    text_price2={`35.00`}


                  />
                </div>
              </div>

              <div className="row align-items-center
               justify-content-center mb-5 d9d9d9 py-5">
                <div className="col-md-10 register-card ">
                  <RegisterCard
                    image_src={puppy}
                    title="Puppy Registration"
                    className="puppies"
                    text1="Register your puppy with us"
                    text2="Age: less than 12 months old"
                    // cancelled_text={'$30.00'}
                    text_price={`25.00`}
                    text_price2={`30.00`}
                  />
                </div>
              </div>

              <div className="row align-items-center justify-content-center mb-5 py-5 ">
                <div className="col-md-10 register-card ">
                  <RegisterCard
                    image_src={litter}
                    title="Litter Registration"
                    className="puppies "
                    text1="Register a collection of puppies with us"
                    shiftRight="order-1 order-sm-3"

                    text_price={`20.00`}
                    text_price2={`25.00`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Registration;
